module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.id,
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.setCurrentCategory(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', {
      on: {
        "click": function($event) {
          _vm.removeItem(item.id)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v(_vm._s(_vm.tileActionIcon))])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-731bb74a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/app/Categories.vue
// module id = 492
// module chunks = 1